export default {"src":"/kaimono/_next/static/media/wamazing_m.213f76e1.svg","height":176,"width":176};